<section class="w-full px-15">
    <div class="container px-5 py-24 mx-auto">
        <div class="flex flex-col">
            <div class="flex items-baseline">
                <h6
                    class="uppercase font-semibold tracking-widest text-lg text-primary-500 sm:mr-3"
                >
                    Testimonials
                </h6>
                <div class="hidden md:flex">
                    <span class="w-10 border-b-2 border-primary-500"></span>
                    <span class="w-2 ml-1 border-b-2 border-primary-500"></span>
                    <span class="w-2 ml-1 border-b-2 border-primary-500"></span>
                </div>
            </div>
            <h1
                class="mt-3 text-xl font-semibold font-primary tracking-wide text-left md:text-3xl lg:text-6xl"
            >
                What They're saying About Our Company
            </h1>
        </div>
        <div class="flex flex-wrap mt-5">
            @for(testimonial of view.testimonials?.content; track testimonial) { 
            <fuse-card class="p-4 md:w-1/3 w-full">
                <div
                    class="h-full bg-white p-8 border-b-4 border-primary-400 hover:shadow-lg"
                >
                    <div class="flex justify-between items-center">
                        <mat-icon
                            class="icon-size-12 text-primary-400"
                            svgIcon="mat_solid:format_quote"
                        ></mat-icon>
                        <div class="flex">
                            <mat-icon
                                class="icon-size-5 text-primary-600"
                                svgIcon="mat_solid:star"
                            ></mat-icon>
                            <mat-icon
                                class="icon-size-5 text-primary-600"
                                svgIcon="mat_solid:star"
                            ></mat-icon>
                            <mat-icon
                                class="icon-size-5 text-primary-600"
                                svgIcon="mat_solid:star"
                            ></mat-icon>
                        </div>
                    </div>
                    <p class="leading-relaxed mb-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        In scelerisque semper elit non pellentesque. Curabitur
                        neque arcu, efficitur facilisis porta at, feugiat ut
                        est. Vivamus sed dui in dui vehicula congue. Phasellus
                        sed pellentesque nisi. Phasellus tempus bibendum massa
                        ut tincidunt. Nam hendrerit ut tortor eget rutrum.
                        Suspendisse facilisis ante eget fringilla auctor. Nam a
                        odio orci. Pellentesque imperdiet quis sem
                    </p>
                    <a class="inline-flex items-center">
                        <img
                            alt="testimonial"
                            src="assets/images/avatars/male-01.jpg"
                            class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"
                        />
                        <span class="flex-grow flex flex-col pl-4">
                            <span class="title-font font-medium text-gray-900"
                                >Jon Doe</span
                            >
                            <span class="text-primary-500 text-sm"
                                >Mauritius Get a way</span
                            >
                        </span>
                    </a>
                </div>
            </fuse-card>
            }

        </div>
    </div>
</section>